import { useEffect, useState, type CSSProperties } from 'react';
import './brand-analysis-status.css';

// Stable coordinates keep the CSS-only loop independent of React renders.
const dots = Array.from({ length: 49 }, (_, index) => {
  const row = Math.floor(index / 7);
  const column = index % 7;
  return {
    accent: row >= 2 && row <= 4 && column >= 2 && column <= 4,
    style: {
      '--x': `${column * 14}px`,
      '--y': `${row * 11}px`,
      '--dx': `${Math.sin(index * 2.4) * 24 + (column - 3) * 5}px`,
      '--dy': `${Math.cos(index * 1.7) * 10 + (row - 3) * 2}px`,
      '--delay': `${-(row + column) * .035}s`,
    } as CSSProperties,
  };
});

/** Mounted only while the existing analysis/save request is pending. */
export function BrandAnalysisStatus() {
  const [longWait, setLongWait] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLongWait(true), 30_000);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <section className="brand-analysis-status" data-testid="brand-analysis-status">
      <div className="brand-analysis-status__motion" aria-hidden="true">
        <div className="brand-analysis-status__dots">
          {dots.map((dot, index) => (
            <span key={index} className={`brand-analysis-status__dot${dot.accent ? ' brand-analysis-status__dot--accent' : ''}`} style={dot.style} />
          ))}
        </div>
      </div>
      <div className="brand-analysis-status__copy" role="status" aria-live="polite" aria-atomic="true">
        <h3>{longWait ? 'Still analyzing your brand' : 'Analyzing your brand'}</h3>
        <p>{longWait
          ? 'This is taking a little longer. We’re still working on your brand.'
          : 'Reading your website and preparing your brand’s colors, voice, and product context.'}</p>
      </div>
      <p className="brand-analysis-status__note">{longWait
        ? 'You don’t need to submit your website again.'
        : 'Some websites take a little longer to read.'}</p>
    </section>
  );
}
